import React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  .line {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    &:not(:first-child) {
      margin-left: 10px;
    }

    background-color: #4b9cdb;
    &:nth-last-child(1) {
      background-color: ${({ theme }) => theme.green};
    }
    &:nth-last-child(2) {
      background-color: ${({ theme }) => theme.yellowish};
    }
    &:nth-last-child(3) {
      background-color: ${({ theme }) => theme.lightblue};
    }
    &:nth-last-child(4) {
      background-color: ${({ theme }) => theme.orange};
    }
  }
  .load-3 .line:nth-last-child(1) {
    animation: loadingC 0.6s 0.1s linear infinite;
  }
  .load-3 .line:nth-last-child(2) {
    animation: loadingC 0.6s 0.2s linear infinite;
  }
  .load-3 .line:nth-last-child(3) {
    animation: loadingC 0.6s 0.3s linear infinite;
  }
  .load-3 .line:nth-last-child(4) {
    animation: loadingC 0.6s 0.4s linear infinite;
  }
  @keyframes loadingC {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(0, 15px);
    }
    100% {
      transform: translate(0, 0);
    }
  }
`;

function Loading() {
  return (
    <Wrapper>
      <div className="load-wrapp">
        <div className="load-3">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Loading;
